// extracted by mini-css-extract-plugin
export var loadingSpinner = "_59-1";
export var standaloneTable = "_59-0";